import React from 'react';
import { Tabs } from 'antd';
import styles from './index.module.less';
import TrafficBucketContent from './TrafficBucketContent';
const { TabPane } = Tabs;
export default function TrafficBucket(props) {
    const { title, tabs = [] } = props;
    return (<div className={styles['traffic-bucket']}>
      <header>{title}</header>
      <div className={styles['traffic-bucket-wrapper']}>
        <Tabs className="traffic-bucket-tabs">
          {tabs.map((tab) => (<TabPane tab={tab.classifyName} key={tab.classifyCode}>
              <TrafficBucketContent {...tab}/>
            </TabPane>))}
        </Tabs>
      </div>
    </div>);
}
